var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-breadcrumb-cartao',{attrs:{"filtroAplicado":"Nenhum filtro aplicado.","semFiltro":false,"arrTexto":_vm.arrTexto,"titulo":"Dashboard","breadcrumb":_vm.bread,"icone":"pie-chart"},on:{"limpar-filtro":_vm.limparFiltro}},[_c('ContainerDashboard',{on:{"mudar-lista-filtro":_vm.mudarListaFiltro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }